import { FormState, Select } from '@vtex/admin-ui-form'
import { FormattedMessage } from 'react-intl'
import { OPERATORS } from 'typings'
import { messages } from './messages'

type Props = {
  name: string
  form: FormState
}

const operatorValues = [
  {
    value: OPERATORS.EQUALS,
    label: <FormattedMessage {...messages.operator.equalsTo} />,
  },
  {
    value: OPERATORS.DIFFERENT,
    label: <FormattedMessage {...messages.operator.differentFrom} />,
  },
]

export function OperatorSelector(props: Props) {
  const { name, form } = props

  return (
    <Select name={name} onClick={(e) => e.stopPropagation()} state={form}>
      {operatorValues.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}
